import { OAuth } from '@core/oauth/model';
import { HttpStatusCode } from '@core/http';

export namespace OAuthUtils {
  import OAuthHttpError = OAuth.OAuthHttpError;
  import OAuthErrorCode = OAuth.OAuthErrorCode;

  const defaultMessage = 'Une erreur technique est survenue.';

  export function getOAuthErrorMessage(error: OAuthHttpError): string {
    switch (error.status) {
      case HttpStatusCode.BAD_REQUEST:
        switch (error.data?.error) {
          case OAuthErrorCode.InvalidGrant:
            return 'Email ou mot de passe incorrect.';
          case OAuthErrorCode.UnsupportedGrantType:
            return 'PLATFORM.GARDEN a besoin que vous changiez votre mot de passe. Veuillez utiliser le formulaire de mot de passe oublié pour continuer.';
          case OAuthErrorCode.AccessDenied:
            return 'Cet espace est réservé aux membres ayant souscrit à l’abonnement PRO';
          default:
            return defaultMessage;
        }
      default:
        return defaultMessage;
    }
  }
}
